import angular, { ILogService } from 'angular'
import { NotificacionService } from '../../../../_panel/module/uni-base/services/NotifService'
import { IModelMenu } from '../../../../model/candidato-api'
import { AccesoDatos } from '../../../comun/services/acceso-datos'
import { Editor } from '../base-editor/editor'
import { EditorBaseCtrl } from '../base-editor/editor-base'

class EditorMenuComponentCtrl extends EditorBaseCtrl<IModelMenu> {
  editor: Editor<IModelMenu>

  constructor(
    $log: ILogService,
    private NotifService: NotificacionService,
    AccesoDatos: AccesoDatos
  ) {
    super($log, new Editor(AccesoDatos.menuResource))
  }

  $onInit(): void {
    this.$log.info('[EditorMenuComponentCtrl] onInit')

    this.editor = this._editor

    this._editor.refresh().then(() => {
      this.NotifService.good('Datos leídos')
    })
  }
}

angular.module('candidato').component('editorMenu', {
  bindings: {},
  controller: EditorMenuComponentCtrl,
  template: require('./editor-menu.component.html'),
})
